import React, { useState } from 'react';
import { Field, FieldsManager } from '../../../../data/services/fields';
import ModalFooter from '../../modal/modal-footer';
import Fields from "../../../../components/fields/fields";

export default function EditColumnWidthDialog({translate, options, selectedItem, onClose, saveTableOptions}) {
    const [fields, setFields] = useState(getFields());
    const [isStateDirty, setIsStateDirty] = useState(false);

    function handleInputChange(name, value) {
        let fieldsClone = Object.assign({}, fields);
        fieldsClone = FieldsManager.updateField(fieldsClone, name, value);
        setFields(fieldsClone);
        setIsStateDirty(true);
    }

    function getFields() {
        return {
            ColumnWidth: new Field('ColumnWidth', options.columns[selectedItem.key].minWidth, ['empty'], false, 'number'),
        }
    }

    function updateColumnWidth(e) {
        if (e) {
            e.preventDefault();
        }

        options.columns[selectedItem.key].minWidth = fields.ColumnWidth.value < 50 ? 50 : fields.ColumnWidth.value;
        saveTableOptions(Object.assign({}, options));
        onClose();
    }

    function resetToDefault() {
        options.columns[selectedItem.key].minWidth = 200; // define default value somewhere

        saveTableOptions(Object.assign({}, options));
        onClose();
    }

    return (
        <React.Fragment>
            <form onSubmit={updateColumnWidth} className="p-5">
                <Fields
                    fieldsState={fields}
                    onInputChange={handleInputChange}
                    translate={translate}
                />
            </form>

            <div className="w-full">
                <ModalFooter
                    closeButtonLabel={translate('btn.close')}
                    onClose={onClose}

                    buttonLabel={translate('btn.updateColumnWidth')}
                    buttonDisabled={!isStateDirty}
                    onButtonClick={updateColumnWidth}

                    secondaryButtonLabel={"Reset to default"}
                    onSecondaryButtonClick={resetToDefault}
                />
            </div>
        </React.Fragment>
    )
}


